export namespace Toro {
    export enum Environment {
        Prod,
        Beta,
        Dev,
        ITC,
        LXC,
        Wifi,
        // AppTeamDev,
        // AppTeamTest,
        // AppTeamDev2,
        Local
    }

    export enum AddOrEdit {
        Add,
        Edit
    }

    export enum OnOff {
        On,
        Off
    }

    export enum NavTab {
        Location,
        IrrDashboard,
        IrrSchedules,
        IrrSchedules_Schedule,
        IrrZones,
        IrrControllers,
        LightDashboard,
        LightSechedules,
        LightLights,
        LightScenes,
        LightThemes,
        LightingFixtures
    }

    export enum ContainerState {
        Closed,
        Open
    }

    export enum AccountType {
        Administered,
        Representing
    }

    export enum DeviceTypeIdToString {
        CLM1 = 'Climate Logic Receiver Module',
        WS = 'Weathor sensor ET',
        SPOD = 'Smart Pod',
        CLMR = 'Mini receiver',
        RMT = 'Remote',
        PSSSEN = 'PSS Moisture sensor',
        PSSRX = 'PSS Moisture receiver',
        LPRO = 'LPRO',
        LPCU = 'LPCU',
        MAGNETO = 'MAGNETO',
        RS9 = 'RainSensor 9000',
        EVOSC = 'Evo Smart Connector',
        SCG = 'Gateway',
        TMC424 = 'TMC-424',
        TMC212 = 'TMC-212',
        Ex = 'EcXtra',
        CC = 'Custom Command',
        RD = 'Rain Dial',
        TC = 'Total Control',
        KD = 'Kwik dial',
        MCE = 'MC-E',
        KD2 = 'KD2',
        EVO = 'Evolution',
        EVOAG = 'Evolution Ag',
        CLASS20 = 'class 20 device',
        CLASS40 = 'class 40 device',
        LXCSC = "SMRT-R",
        LXCEXP = "LXC-EXP",
        LXCTM = "LXC-TM",
        UNK = 'Unknown Device'
    }

    export enum DeviceTypeId {
        'Climate Logic Receiver Module' = 1,
        'Weathor sensor ET' = 2,
        'Smart Pod' = 3,
        'Mini receiver' = 4,
        'Remote' = 5,
        'PSS Moisture sensor' = 6,
        'PSS Moisture receiver' = 7,
        'LPRO' = 8,
        'LPCU' = 9,
        'MAGNETO' = 26,
        'RainSensor 9000' = 10,
        'Evo Smart Connect' = 11,
        'Gateway' = 12,
        'TMC-424' = 13,
        'TMC-212' = 14,
        'EcXtra' = 15,
        'Custom Command' = 16,
        'Rain Dial' = 17,
        'Total Control' = 18,
        'Kwik dial' = 19,
        'MC-E' = 20,
        'KD2' = 21,
        'Evolution' = 24,
        'LXCSC' = 27,    //TODO LXC   Total control enhanced SC
        'LXCEXP' = 28,
        'LXCTM' = 29,
        'Evolution Ag' = 25,
        'class 20 device' = 250,
        'class 40 device' = 251,
        'Unknown Device' = 9999
    }

    export enum DeviceType {
        CLM1 = 1,
        WS = 2,
        SPOD = 3,
        CLMR = 4,
        RMT = 5,
        PSSSEN = 6,
        PSSRX = 7,
        LPRO = 8,
        LPCU = 9,
        MAGNETO = 26,
        RS9 = 10,
        EVOSC = 11,
        SCG = 12,
        TMC424 = 13,
        TMC212 = 14,
        Ex = 15,
        CC = 16,
        RD = 17,
        TC = 18,
        KD = 19,
        MCE = 20,
        KD2 = 21,
        EVO = 24,
        EVOAG = 25,
        LXCSC = 27,    //TODO LXC   SMRT-R
        LXCEXP = 28,
        LXCTM = 29,
        CLASS20 = 250, // Any class 20 devices: 1,3,4,6 (pss), 7 and 2 Irritrol
        CLASS40 = 251, // Any class 40 devices: 2(evo), 5, 6(evo) 8,9,10,11,12 & future
        UNK = 9999
    }

    export enum ProgramStatus {
        idle = 0,
        soaking = 1,
        running = 2,
        disabled = 3,
        unknown = 4
    }

    export enum WaterDayMode {
        weekDays = 0,
        oddDays = 1,
        evenDays = 2,
        intervalDays = 3,
        unknown = 4
    }

    export enum AlarmWarning
    {
        None,
        StationShorted,
        StationOverCurrentWarning,
        FlowSensorOneAlarm,
        FlowSensorTwoAlarm,
        FlowSensorThreeAlarm,
        FlowSensorOneWarning,
        FlowSensorTwoWarning,
        FlowSensorThreeWarning,
        MasterValve1Shorted,
        MasterValve2Shorted,
        MasterValve3Shorted,
        MasterValve1OverCurrentWarning,
        MasterValve2OverCurrentWarning,
        MasterValve3OverCurrentWarning,
        FlowSensorUnexpectedFlowMVOne,
        FlowSensorUnexpectedFlowMVTwo,
        FlowSensorUnexpectedFlowMVThree
    }

    export enum HttpResponseStatusCode {
        Offline = 0,
        Unauthorized = 401
    }

    export enum ZoneRunningState {
        Idle,
        Watering,
        Soaking
    }

    export enum NotificationTypeCode {
        ConfigsAreDifferentNotification = 0,
        DeviceAdded = 1,
        MessageMarkedFailedNotification = 2,
        DeviceBusyNotification = 4,
        DeviceHasDifferentSchedule,
        DeviceHasDifferentApanSetup,
        DeviceSetConfigFailed,
        FirmwareUpgradeProgressNotification,
        NewNetworkConfiguration,
        NewDeviceDiscoveredNotification,
        ChangeInSceneForceStatusNotification,
        ULReportSetConfigNotification,
        IrrigationTestStationsNotification,
        IrrigationStationOnOffNotification,
        IrrigationProgramStartStopNotification,
        IrrigationControllerAllOffNotification,
        IrrigationRunningModeNotification,
        RunningModeChangeAcceptedNotification,
        IrrigationControllerReSyncRecordsNotification,
        IrrigationControllerRecordChangeNotification,
        IrrigationControllerStatusChangedNotification,
        EvoAddReplaceProcessUpdateNotification,
        LPCUStatusIsUpdatedNotification,
        LogReportNotification,
        HistoryReportNotification,
        IncomingMessageNotification,
        MailCenterNotification,
        CLAddReplaceProcessUpdateNotification,
        IncomingReportFailedNotification,

        AddMagnetoNotification,
        MagnetoSceneOrThemePlayNotification,
        MagnetoGetConfigNotification,
        MagentoSyncStatusMatchedNotification,
        LxcAddReportNotification
    }

    export enum NotificationType {
        ChangeInSceneForceStatusNotification = 'ChangeInSceneForceStatusNotification',
        ChangeInThemeForceStatusNotification = 'ChangeInThemeForceStatusNotification',      //Dont use this notification, no more used in server side
        DeviceBusyNotification = 'DeviceBusyNotification',
        EvoAddReplaceProcessUpdateNotification = 'EvoAddReplaceProcessUpdateNotification',
        FirmwareUpgradeProgressNotification = 'FirmwareUpgradeProgressNotification',
        ConfigsAreDifferentNotification = 'ConfigsAreDifferentNotification',
        GatewayNewDeviceDiscoveredNotification = 'NewDeviceDiscoveredNotification',
        IncomingReportFailedNotification = 'IncomingReportFailedNotification',
        IrrigationControllerRecordChange = 'IrrigationControllerRecordChangeNotification',
        IrrigationControllerRecordReSync = 'IrrigationControllerReSyncRecordsNotification',
        IrrigationControllerStatusChanged = 'IrrigationControllerStatusChangedNotification',//multiple times ..
        IrrigationControllerAllOff = 'IrrigationControllerAllOffNotification',              //stop station irrigation
        IrrigationControllerProgramStartStop = 'IrrigationProgramStartStopNotification',    //on play/start program click
        IrrigationControllerStationOnOff = 'IrrigationStationOnOffNotification',            //on play/start station tile click
        LPCUStatusIsUpdatedNotification = 'LPCUStatusIsUpdatedNotification',
        MailCenterNotification = 'MailCenterNotification',
        RunningModeChangeAccepted = 'RunningModeChangeAcceptedNotification',
        ULReportSetConfigNotification = 'ULReportSetConfigNotification',

        //Magneto Notification
        MagnetoGetConfigNotification = 'MagnetoGetConfigNotification',
        MagnetoDiscoveryNotification = 'MagnetoDiscoveryNotification',              //Dont use this notification, not needed for now
        MagnetoRecordChangeNotification = 'MagnetoRecordChangeNotification',        //unused
        AddMagnetoNotification = 'AddMagnetoNotification',
        MagnetoSceneChangeNotification = 'MagnetoSceneChangeNotification',                   //unused
        MagnetoThemeChangeNotification = 'MagnetoThemeChangeNotification',                   //unused
        MagnetoFixtureThemeSaveNotification = 'MagnetoFixture_ThemeSaveNotification',        //unused
        MagnetoFixturePreviewNotification = 'MagnetoFixturePreviewNotification',             //unused
        MagnetoSyncSetConfigR1Notification = 'MagnetoSync_SetConfigNotification_R1',         //unused
        MagnetoSyncSetConfigR2Notification = 'MagnetoSync_SetConfigNotification_R2',         //unused
        MagnetoSyncStatusCommandErrorNotification = 'MagnetoSync_StatusCommandError',
        MagnetoSyncStatusMatchedNotification = 'MagnetoSync_StatusMatchedNotification',
        MagnetoScenePlayNotification = 'MagnetoScenePlayNotification',
        MagnetoThemePlayNotification = 'MagnetoThemePlayNotification',
        MagnetoStatusIsUpdatedNotification = 'MagnetoStatusIsUpdatedNotification',          //Dont use this notification, no more used in server side

        //LXC Notification
        LxcAddReportNotification = "LxcAddReportNotification"
    }

    export enum RunningMode {
        On = 0,
        Off = 1,
        OffForDays = 2,
        OffUntilNextSchedStart = 3
    }

    export enum SensorWetDryState {
        Dry = 0,
        Wet = 1
    }

    export enum SensorWarmFreezeState {
        Warm = 0,
        Freeze = 1
    }

    export enum CalibrationStatus {
        NotCalibrating = 0,
        Calibrating = 1,
        CalibrationSuccess = 2,
        CalibrationFail = 3
    }

    export enum CalibrationResult {
        NeverStarted = 0,
        Success = 1,
        Calibrating = 2,
        PowerFailure = 3,
        NotEnoughData = 4,
        BadData = 5,
    }

    export enum WeatherForecastConditions {
        Sunny = 'Sunny',
        PartlySunny = 'Partly Sunny',
        Cloudy = 'Cloudy',
        PartlyCloudy = 'Partly Cloudy',
        Showers = 'Showers',
        Rainfall = 'Rainfall',
        Thunderstorm = 'Thunderstorm',
        Snow = 'Snow',
        Sleet = 'Sleet',
        FreezingRain = 'Freezing Rain',
        Drizzle = 'Drizzle'
    }

    export enum SceneScheduleAorB {
        A = 'ScheduleA',
        B = 'ScheduleB'
    }

    export enum SceneScheduleDaySelectionList {
        Custom,
        All,
        Weekdays,
        Weekends,
        None
    }

    export enum SceneScheduleTimeSelectionList {
        Time = 'Time',
        Dawn = 'Dawn',
        Dusk = 'Dusk'
    }

    export enum SceneScheduleTimePeriod {
        am = 'am',
        pm = 'pm'
    }

    export enum SceneOnWithOrWithoutDuration {
        WithDuration,
        WithoutDuration
    }

    export enum ThemeOnWithOrWithoutDuration {
        WithDuration,
        WithoutDuration
    }

    export enum FixtureType {
        Auto = 0,
        "Up Light(Adjustable Beam)" = 1,
        "Down Light(Adjustable Beam)" = 2,
        "Area Light" = 3,
        "Well Light(Adjustable Beam)" = 4,
        "Up Light" = 5,
        "Down Light" = 6,
        "Well Light" = 7

    }

    export enum RepeatMode {
        "No Repeat" = 0,
        "Repeat Inspira" = 1,
        "Repeat All" = 2
    }

    export enum RunningStatus {
        Idle = 0,
        Soaking = 1,
        Running = 2,
        Disabled = 3,
        Unknown = 4
    }

    export enum ModeSwitchPosition {
        OffOrStop = 0,
        SetProgram = 1,
        RunOrManual = 2,
        RunOrProgram = 3
    }

    export enum ProgramWaterDays {
        weekDays = 0,
        oddDays = 1,
        evenDays = 2,
        intervalDays = 3
    }

    export enum ClimateLogicType {
        wirelessReceiver = 1,
        miniReceiver = 4
    }

    export enum TemperatureUnit {
        Fahrenheit = 0,
        Celsius = 1
    }

    export enum Units {
        Metric = 0,
        English = 1
    }

    export enum ImageAssetType {
        Location,
        Controller,
        Zone,
        Scene,
        Theme
    }

    export enum DocumentType {
        None,
        About,
        Support,
        TermsOfService,
        PrivacyPolicy,
        PinInfo,
        Configuration,
        WhatsNew,
    }

    export enum ImageChangeType {
        Change,
        Delete,
    }

    export enum ClimateLogicSensorStatus {
        HoldRain = 0,
        WaterDryWarm = 1,
        HoldFreeze = 2,
        WaterBypassed = 3,
        HoldDryout = 4,
        HoldWaterRetrict = 5,
        HoldAutoModeOff = 6,
        Unknown = 255
    }

    export enum CurrentWateringModeActivationReason {
        Off = 0xFF,
        ProgramA = 0x00,
        ProgramB = 0x01,
        ProgramC = 0x02,
        ManualA = 0x03,
        ManualB = 0x04,
        ManualC = 0x05,
        ManualStation = 0x06,
        ManualTest = 0x07,
        Pause = 0x08,
        TrueManual = 0x09,
        ManualRemoteStation = 0x0A
    }

    export enum ClmControlledManualOperation {
        None = 0,
        TestAllEnabled = 1,
        ManualStation = 2,
    }

    export enum RainDialZoneDelayUnit {
        None = 0,
        Seconds = 1,
        Minutes = 60,
        Hours = 3600,
    }

    export enum TimeField {
        None,
        All,
        Hour,
        Minute,
        Meridiem,
        Hidden
    }

    export enum RuntimeField {
        None,
        All,
        Hour,
        Minute,
        Hidden
    }

    export enum TimeOption {
        Time,
        Dusk,
        Dawn,
        Disable
    }

    export enum LpcuSchedule {
        A,
        B,
    }

    export enum DayFlag {
        Sun = 1,
        Mon = 2,
        Tue = 4,
        Wed = 8,
        Thu = 16,
        Fri = 32,
        Sat = 64
    }

    export enum UlUpdateType {
        Device,
        SceneCreate,
        SceneUpdate,
        ThemeCreate,
        ThemeUpdate
    }

    export enum AutoProgramAdjust {
        A,
        AandB,
        AandBandC,
        None
    }

    export enum LxcBlockId {
        SMRT_R = 173,
        CRC_BLOCK = 0,
        HEADER_BLOCK = 1,
        DAILY_COUNTER_BLOCK = 2,
        CONTROLLER_BLOCK = 3,
        SOAK_TABLE_BLOCK = 4,
        CYCLE_TALBE_BLOCK = 5,
        START_01_BLOCK = 6,
        START_02_BLOCK = 7,
        START_03_BLOCK = 8,
        START_04_BLOCK = 9,
        START_05_BLOCK = 10,
        START_06_BLOCK = 11,
        START_07_BLOCK = 12,
        START_08_BLOCK = 13,
        RUNTIME_01_BLOCK = 14,
        RUNTIME_02_BLOCK = 15,
        RUNTIME_03_BLOCK = 16,
        RUNTIME_04_BLOCK = 17,
        RUNTIME_05_BLOCK = 18,
        RUNTIME_06_BLOCK = 19,
        RUNTIME_07_BLOCK = 20,
        RUNTIME_08_BLOCK = 21,
        WATER_01_BLOCK = 22,
        WATER_02_BLOCK = 23,
        WATER_03_BLOCK = 24,
        WATER_04_BLOCK = 25,
        WATER_05_BLOCK = 26,
        WATER_06_BLOCK = 27,
        WATER_07_BLOCK = 28,
        WATER_08_BLOCK = 29,
        FS_1_LEARN_BLOCK = 30,
        FS_2_LEARN_BLOCK = 31,
        FS_1_CONF_BLOCK = 32,
        FS_2_CONF_BLOCK = 33,
        TOTALIZER_1_BLOCK = 34,
        TOTALIZER_2_BLOCK = 35,
        RTC = 36,
        RESERVE_01 = 37,
        MANUAL_CMD_BLOCK = 38,
        RESERVE_02 = 39,
        SEMI_PROGRAM_BLOCK = 40,
        MANUAL_COUNTER_BLOCK = 41,
        MANUAL_C_STATUS_BLOCK = 42,
        AUTO_COUNTER_BLOCK = 43,
        AUTO_C_STATUS_BLOCK = 44,
        SUMMARY_STATUS_BLOCK = 45,
        SOAK_C_STATUS_BLOCK = 46,
        SEQ_COUNTER_STATUS_BLOCK = 47,
        SEQ_MANUAL_LIST_BLOCK = 48,
        PAUSE_STATUS_BLOCK = 49,
        TEST_BLOCK = 50,
        STATION_NAME_BLOCK = 51,
        SCHEDULE_NAME_BLOCK = 52,
        CONTROLLER_NAME_BLOCK = 53
    }

    export enum TriggerAction {
        NO_ACTION,
        START_PROGRAM,
        STOP_PROGRAM,
    }

    export enum OnOrOffOption  {
            Off,
            On
        }

    export enum MasterValvePumpSetting{
        MasterValveAndNC = 0,
        MasterValveAndNO = 1,
        PumpAndNC = 2, //  (pump is always NC = off)
        //PumpAndNC2 = 3 //  (pump is always NC = off)
    }

    export enum RainSensorBypass
    {
        Default = 0,
        Bypassed = 1
    }

    export enum PumpOptInList{
        'No PUMP' = 8 ,                 //1000
        'PUMP 1',                       //1001
        'PUMP 2',                       //1010
    }

    /* public pumpOptInList = [
        { Text: 'No Master Valve', Value: 0 },              //0000
        { Text: 'Master Valve 1', Value: 1 },               //0001
        { Text: 'Master Valve 2', Value: 2 },               //0010
        { Text: 'Master Valve 1 & 2', Value: 3 },           //0011
        { Text: 'Master Valve 3', Value: 4 },               //0100
        { Text: 'Master Valve 1 & 3', Value: 5 },           //0101
        { Text: 'Master Valve 2 & 3', Value: 6 },           //0110
        { Text: 'Master Valve 1, 2,&3', Value: 7 },         //0111
        { Text: 'No PUMP', Value: 8 },                      //1000
        { Text: 'PUMP 1', Value: 9 },                       //1001
        { Text: 'PUMP 2', Value: 10 },                      //1010
        { Text: 'PUMP 1&2', Value: 11 },                    //1011
        { Text: 'PUMP 3', Value: 12 },                      //1100
        { Text: 'PUMP 1 & 3', Value: 13 },                  //1101
        { Text: 'PUMP 2 & 3', Value: 14 },                  //1110
        { Text: 'PUMP 1,2,&3', Value: 15 }                  //1111
    ]; */

    export enum StatusCodes {
        /// 0   The download has just started
        InitializingDownload = 0,

        /// 1   The download is in progress
        DownloadInProgress,

        /// 2   The download is completed
        Completed,

        /// 3   The download failed due to no communication between gateway and device
        FailedDueToNoRf,

        /// 4   The download failed due to checksum
        FailedDueToChecksum,

        /// 5 The download failed due to SPI retry
        FailedDueToSPIRetry,

        /// 6   The download failed due to Download Cancel
        FailedDueToDownloadCancel = 6,

        /// 12  The download failed due to failure to write to memory
        FailedDueToFlashWriteError = 12,

        Unknown = 9999
    }
}
